import type { ReactNode } from "react";
import { resolveVehicleModel } from "../../config/vehicleModels";
import { useTheme } from "../../context/ThemeContext";
import { useVehicleGarage } from "../../features/vehicles/pointerModel";
import VehicleStage from "../../pages/home/components/VehicleStage";

// La carátula del vehículo (con lápiz para cambiarlo en el garaje) donde
// Administración mostraba un ícono de camión. Si la unidad usa el marcador
// "Clásico" (o es un remolque suelto), se queda el ícono de siempre.
export default function UnitVehicleAvatar({
  vehicleId,
  name,
  pointerModel,
  bodyType,
  unitType,
  fallback,
  editable = true,
  size = "chip",
  className = "",
}: {
  vehicleId: string;
  name: string;
  pointerModel?: string;
  bodyType?: string;
  unitType?: string;
  /** Lo que se mostraba antes (foto o ícono), para "Clásico". */
  fallback: ReactNode;
  editable?: boolean;
  size?: "chip" | "hero";
  className?: string;
}) {
  const { isDarkMode } = useTheme();
  const model = resolveVehicleModel(pointerModel, bodyType, unitType);
  const open = () => useVehicleGarage.getState().open({ vehicleId, name, bodyType, current: pointerModel });
  if (!model) {
    return editable ? (
      <span className={`relative inline-flex shrink-0 ${className}`}>
        {fallback}
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            open();
          }}
          aria-label="Cambiar vehículo"
          title="Cambiar vehículo"
          className={`absolute -right-1 -top-1 w-5 h-5 rounded-md flex items-center justify-center ${isDarkMode ? "bg-black/60 text-white/80" : "bg-white text-gray-600 shadow-sm"}`}
        >
          <i className="ri-pencil-line text-[11px] leading-none" aria-hidden />
        </button>
      </span>
    ) : (
      <span className={`inline-flex shrink-0 ${className}`}>{fallback}</span>
    );
  }
  return <VehicleStage model={model} size={size} isDarkMode={isDarkMode} className={`shrink-0 ${className}`} onEdit={editable ? open : undefined} />;
}
